import React, { useState, useEffect } from "react";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import HeadingText from "components/common/HeadingText/HeadingText";
import { Col, Container, Form, Row } from "reactstrap";
import TextField from "components/common/TextField/TextField";
import "./AddUpdateCnicVerificationPage.scss";
import ButtonComponent from "components/common/Button/ButtonComponent";
import { Can } from "config/Can";
import { Label } from "reactstrap";
import {
  IAddUpdateCnicVerificationPageProps,
  ISearchSelectChange,
} from "interfaces/Index";
import LoaderComponent from "components/common/Loader/Loader";
import IconBackArrow from "assets/images/back_arrow.svg";
import { getCnicImageApiCall } from "redux/sources/CnicVerificationSource";
import Modal from "components/common/Modal/Modal";
import SearchableSelect from "components/common/SearchableSelect/SearchableSelect";
import Tabs from "components/common/Tabs/Tabs";
import CnicInfo from "./CnicInfo/CnicInfo";
import { toTitleCase } from "utils/lib";
import Checkbox from "components/common/Checkbox/Checkbox";
import { CUSTOMER_CHANNEL } from "../../../config/constants";

import {
  CNIC_STATUS,
  CNIC_VERIFICATION_TYPE,
  CNIC_MODAL_TYPE,
  CNIC_DISQUALIFICATION_REASONS_GENERAL_TRADE,
  CNIC_DISQUALIFICATION_REASONS_HORECA,
  CNIC_VERIFITCATION_USER_TYPE,
  OWNER_VERIFICATION_STATUS,
} from "config/constants";

const AddUpdateCnicVerificationPage: React.FunctionComponent<
  IAddUpdateCnicVerificationPageProps
> = (props) => {
  const {
    backButtonHandler,
    error,
    isError,
    isCnicVerificationDataUpdated,
    cnicVerificationData: {
      userId,
      backImageId,
      frontImageId,
      nationalId,
      userImageId,
      // status,
      storeName = "",
      customerChannel,
      owner,
      verificationStatus,
    },
    isLoading,
    verifyCnicData,
    dummyModalType,
  } = props;
  
  const [frontCnicImage, setFrontCnicImage] = useState("");
  const [backCnicImage, setBackCnicImage] = useState("");
  const [userImage, setUserImage] = useState("");

  const [ownerFrontCnicImage, setOwnerFrontCnicImage] = useState("");
  const [ownerBackCnicImage, setOwnerBackCnicImage] = useState("");
  const [ownerImage, setOwnerImage] = useState("");

  const [ownerExpiryDateState, setOwnerExpiryDateState] = useState<Date | null>(
    null
  );
  const [ownerDateOfBirthState, setOwnerDateOfBirthState] =
    useState<Date | null>(null);

  const [expiryDateState, setExpiryDateState] = useState<Date | null>(null);
  const [dateOfBirthState, setDateOfBirthState] = useState<Date | null>(null);

  const [reasonState, setReasonState] = useState<ISearchSelectChange | null>(
    null
  );

  const [notificationModal, setNotificationModal] = useState(false);
  const [modalType, setModalType] = useState(dummyModalType || "");
  const [uploadAgreementCheck, setUploadAgreementCheck] =
    useState<boolean>(false);

  useEffect(() => {
    getCnicImageApiCall(
      { userId },
      frontImageId,
      CNIC_VERIFICATION_TYPE.nationalid
      ).then((res) => setFrontCnicImage(res.base64));

    getCnicImageApiCall(
      { userId },
      backImageId,
      CNIC_VERIFICATION_TYPE.nationalid
    ).then((res) => setBackCnicImage(res.base64));

    if (userImageId) {
      getCnicImageApiCall(
        { userId },
        userImageId,
        CNIC_VERIFICATION_TYPE.userimage
      ).then((res) => setUserImage(res.base64));
    }

    if (customerChannel === CUSTOMER_CHANNEL.CORPORATE && owner) {
      getCnicImageApiCall(
        { userId },
        owner.cnicFrontImageId,
        CNIC_VERIFICATION_TYPE.nationalid
      ).then((res) => setOwnerFrontCnicImage(res.base64));
      getCnicImageApiCall(
        { userId },
        owner.cnicBackImageId,
        CNIC_VERIFICATION_TYPE.nationalid
      ).then((res) => setOwnerBackCnicImage(res.base64));

      if (owner.ownerImageId) {
        getCnicImageApiCall(
          { userId },
          owner.ownerImageId,
          CNIC_VERIFICATION_TYPE.userimage
        ).then((res) => setOwnerImage(res.base64));
      }
    }
  }, []);

  useEffect(() => {
    if (isCnicVerificationDataUpdated) {
      setNotificationModal(false);
      backButtonHandler(true);
    }
  }, [props.isCnicVerificationDataUpdated]);

  useEffect(() => {
    if (isError) {
      setNotificationModal(false);
      alert((error! as any).errors);
    }
  }, [props.isError]);

  const handleGoBackButton = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    backButtonHandler(false);
  };

  const handleDateChange = (fieldName: string, value: any) => {
    switch (fieldName) {
      case `${CNIC_VERIFITCATION_USER_TYPE.USER}_EXPIRY`:
        value && setExpiryDateState(new Date(value._d));
        break;

      case `${CNIC_VERIFITCATION_USER_TYPE.USER}_DOB`:
        value && setDateOfBirthState(new Date(value._d));
        break;

      case `${CNIC_VERIFITCATION_USER_TYPE.OWNER}_EXPIRY`:
        value && setOwnerExpiryDateState(new Date(value._d));
        break;

      case `${CNIC_VERIFITCATION_USER_TYPE.OWNER}_DOB`:
        value && setOwnerDateOfBirthState(new Date(value._d));
        break;
    }
  };

  const handleSubmit = () => {
    let verifyStatus;
    if (verificationStatus === OWNER_VERIFICATION_STATUS.IDENTITY_VERIFIED) {
      verifyStatus = CNIC_STATUS.OPEN_CREDIT;
    } else {
      verifyStatus =
        modalType === CNIC_MODAL_TYPE.Verify
          ? CNIC_STATUS.VERIFIED
          : CNIC_STATUS.UNVERIFIED;
    }

    verifyCnicData({
      customerId: userId,
      status: verifyStatus,
      expiryDate: expiryDateState
        ? Date.parse(expiryDateState.toString())
        : null,
      dateOfBirth: dateOfBirthState
        ? Date.parse(dateOfBirthState.toString())
        : null,
      kycFailureReason: reasonState ? reasonState.value : "NONE",
    });
  };

  const showModal = (type: string) => {
    return () => {
      setModalType(type);
      setNotificationModal(true);
    };
  };

  const renderBranchManagerInfo = () => (
    <>
      <CnicInfo
        userId={userId}
        nationalId={nationalId}
        expiryDate={expiryDateState}
        dateOfBirth={dateOfBirthState}
        handleDateChange={handleDateChange}
        userType={CNIC_VERIFITCATION_USER_TYPE.USER}
        customerChannel={CUSTOMER_CHANNEL.GENERAL_TRADE}
      />
      {renderCnicImages(
        CNIC_VERIFITCATION_USER_TYPE.MANAGER,
        userImageId,
        frontCnicImage,
        backCnicImage
      )}
    </>
  );

  const renderKarobarDetails = () => {
    return (
      <FormSectionLayout subTitleText="Karobar Details">
        <TextField
          id="storeName"
          label="Karobar Name"
          value={storeName}
          type={"text"}
          placeholder="Karobar Name"
          disabled={true}
        />
      </FormSectionLayout>
    );
  };

  const renderOpenCreditAgreement = () => (
    <FormSectionLayout subTitleText="Agreement">
      <Checkbox
        id="isAgreementCheck"
        label={"Agreement upload hogaya hai"}
        handleCheckboxChange={() =>
          setUploadAgreementCheck(!uploadAgreementCheck)
        }
        isChecked={uploadAgreementCheck}
      />
    </FormSectionLayout>
  );
  const renderOwnerInfo = () => {
    return (
      <>
        {owner && (
          <>
            {owner && owner.status === OWNER_VERIFICATION_STATUS.ACTIVE && (
              <div className="form-group owner-verified">
                <Label className="text-uppercase label">owner verified</Label>
              </div>
            )}

            <CnicInfo
              name={owner.name}
              phoneNumber={owner.phoneNumber}
              nationalId={owner.nationalId}
              expiryDate={ownerExpiryDateState}
              dateOfBirth={ownerDateOfBirthState}
              handleDateChange={handleDateChange}
              userType={CNIC_VERIFITCATION_USER_TYPE.OWNER}
              customerChannel={CUSTOMER_CHANNEL.CORPORATE}
            />

            {renderCnicImages(
              CNIC_VERIFITCATION_USER_TYPE.OWNER,
              ownerImage,
              ownerFrontCnicImage,
              ownerBackCnicImage
            )}
          </>
        )}
        {!owner && (
          <div className="form-group owner-is-manager">
            <Label className="text-uppercase label">manager hi owner hai</Label>
          </div>
        )}
      </>
    );
  };

  const renderHoreacaUserDetails = () => {
    return (
      <FormSectionLayout subTitleText="User Details">
        <Tabs
          tabsData={[
            {
              id: "1",
              tabLink: "MANAGER",
              content: renderBranchManagerInfo(),
            },
            {
              id: "2",
              tabLink: "OWNER",
              content: renderOwnerInfo(),
            },
          ]}
        />
      </FormSectionLayout>
    );
  };

  const renderButtons = () => {
    return (
      <FormSectionLayout subTitleText="">
        <Can I="update" a="nationalid">
          <Row className="add-update-button-container">
            <Col>
              <ButtonComponent
                buttonText={
                  verificationStatus ===
                  OWNER_VERIFICATION_STATUS.IDENTITY_VERIFIED
                    ? "Open Credit"
                    : "Verify"
                }
                isDisable={
                  verificationStatus ===
                    OWNER_VERIFICATION_STATUS.IDENTITY_VERIFIED &&
                  !uploadAgreementCheck
                }
                onClickHandler={showModal(CNIC_MODAL_TYPE.Verify)}
                buttonClass="large-button btn-primary"
              />
            </Col>

            <Col>
              {verificationStatus !==
                OWNER_VERIFICATION_STATUS.IDENTITY_VERIFIED && (
                <ButtonComponent
                  buttonText="Disqualify"
                  onClickHandler={showModal(CNIC_MODAL_TYPE.Disqualify)}
                  buttonClass="large-button btn-primary-outline"
                />
              )}
            </Col>
          </Row>
        </Can>
      </FormSectionLayout>
    );
  };

  const renderUserDetails = () => {
    return (
      <FormSectionLayout subTitleText="User Details">
        <CnicInfo
          userId={userId}
          nationalId={nationalId}
          expiryDate={expiryDateState}
          dateOfBirth={dateOfBirthState}
          handleDateChange={handleDateChange}
          userType={CNIC_VERIFITCATION_USER_TYPE.USER}
          customerChannel={CUSTOMER_CHANNEL.GENERAL_TRADE}
        />

        {renderCnicImages(
          CNIC_VERIFITCATION_USER_TYPE.USER,
          userImageId,
          frontCnicImage,
          backCnicImage
        )}

        {/* {renderButtons()} */}
      </FormSectionLayout>
    );
  };

  const notificationModalState = () => {
    setNotificationModal(!notificationModal);
    setReasonState(null);
  };

  const handleReasonChange = (event: ISearchSelectChange) => {
    setReasonState(event);
  };

  const checkIfNotHoreca = (customerChannel: string): boolean => {
    return Object.values([
      CUSTOMER_CHANNEL.GENERAL_TRADE,
      CUSTOMER_CHANNEL.ELECTRONICS,
      CUSTOMER_CHANNEL.SELF_SERVICE_STORE,
    ] as String[]).includes(customerChannel);
  };

  const renderNotificationModal = () => {
    return (
      <Modal
        showModal={notificationModal}
        closeModalHandler={notificationModalState}
        modalHeading="Are you sure?"
        showProgressString={false}
        failedRecords=""
        modalBodyClass={
          modalType === CNIC_MODAL_TYPE.Disqualify
            ? "cnic-verfication-modal-body"
            : "notification-account"
        }
        containerClass="notification-modal"
      >
        <div id="confirmationModal">
          <p>Are you sure you want to {modalType}?</p>
          {modalType === CNIC_MODAL_TYPE.Disqualify && (
            <SearchableSelect
              label="Reason"
              options={
                checkIfNotHoreca(customerChannel)
                  ? CNIC_DISQUALIFICATION_REASONS_GENERAL_TRADE
                  : CNIC_DISQUALIFICATION_REASONS_HORECA
              }
              id="disqualification-reason"
              onChange={handleReasonChange}
              selectedValue={reasonState}
              placeholder="select a reason"
              isSearchable={false}
            />
          )}
          <Row className="button-container">
            <Col lg="6">
              <ButtonComponent
                buttonClass="button-small btn btn-primary-outline"
                buttonText="Go back"
                onClickHandler={notificationModalState}
              />
            </Col>
            <Col lg="6">
              {
                <ButtonComponent
                  buttonClass="button-small btn btn-primary verify-btn"
                  buttonText="Confirm"
                  isDisable={
                    modalType === CNIC_MODAL_TYPE.Disqualify && !reasonState
                  }
                  onClickHandler={handleSubmit}
                />
              }
            </Col>
          </Row>
        </div>
      </Modal>
    );
  };

  const renderCnicImages = (
    userType: CNIC_VERIFITCATION_USER_TYPE,
    userImageId: string,
    frontImageId: string,
    backImageId: string
  ) => {
    return (
      <>
        {userImageId && (
          <>
            <h1 className="sub-heading">{toTitleCase(userType)} Selfie</h1>
            <div className="cnic-image-container">
              <img
                src={`data:image/${
                  userImageId.split(".")[1]
                };base64, ${userImage}`}
                alt="userImage"
              />
            </div>
          </>
        )}

        <h1 className="sub-heading">{toTitleCase(userType)} CNIC Images</h1>
        <div className="cnic-image-container">
          <img
            src={`data:image/${
              frontImageId.split(".")[1]
            };base64, ${frontCnicImage}`}
            alt="FrontCnicImage"
          />
        </div>
        <div className="cnic-image-container">
          <img
            src={`data:image/${
              backImageId.split(".")[1]
            };base64, ${backCnicImage}`}
            alt="BackCnicImage"
          />
        </div>
      </>
    );
  };

  return (
    <Container fluid className="add-update-cnic-verification-container">
      {renderNotificationModal()}
      {isLoading && <LoaderComponent />}
      <Row>
        <Col lg="5">
          <div className="back-button">
            <a href="#!" onClick={handleGoBackButton}>
              {/* TO-DO: Convert this to a button in all compoents. */}
              <span>
                <img src={IconBackArrow} alt="close" />
              </span>{" "}
              Back to CNIC Verification
            </a>
          </div>
          <HeadingText text={"CNIC Details"} isMainHeading={true} />
        </Col>
      </Row>

      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="cnic-detail">
              {
                <>
                  {renderKarobarDetails()}
                  {renderHoreacaUserDetails()}
                  {verificationStatus ===
                    OWNER_VERIFICATION_STATUS.IDENTITY_VERIFIED &&
                    renderOpenCreditAgreement()}
                </>
              }
              {checkIfNotHoreca(customerChannel) && renderUserDetails()}
              
              {renderButtons()}
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
export default AddUpdateCnicVerificationPage;
